export default "__VITE_ASSET__C7QYwO$G__"